import { render } from "./AddPhoneNumber.vue?vue&type=template&id=5ecc7076&scoped=true"
import script from "./AddPhoneNumber.vue?vue&type=script&lang=js"
export * from "./AddPhoneNumber.vue?vue&type=script&lang=js"

import "./AddPhoneNumber.vue?vue&type=style&index=0&id=5ecc7076&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecc7076"]])

export default __exports__